import type { ProductAttribute } from "../types";

export const getAttributeWithValues = (attributes: ProductAttribute[] | undefined, key: string) => {
  const attribute = attributes?.find((attr) => attr.key === key);
  return attribute && (attribute.values?.length ?? 0) > 0 ? attribute : null;
};

export const getAvailableItems = <T extends object>(items: T[] | undefined, availabilityKey = "is_available") => {
  if (!Array.isArray(items)) return [];

  return items.filter((item) => {
    if (!item) return false;
    const value = item[availabilityKey as keyof T];
    if (typeof value === "string") {
      return value.toLowerCase() === "true";
    }
    return Boolean(value);
  });
};
